import { CommonEnums } from 'src/app/shared/common.enums';

export class Expr_Inst {
    expr_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxMp_Id: number;
    persistFlg: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    attr_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.expr_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.persistFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
    }

    static parse(expr_InstTmp: Expr_Inst): Expr_Inst {
        let expr_Inst: Expr_Inst = new Expr_Inst();
        expr_Inst.copyFrom(expr_InstTmp);
        return expr_Inst;
    }

    gePrimaryKey(): string {
        return this.expr_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): Expr_Inst {
        let expr_InstTmp: Expr_Inst = new Expr_Inst();

        expr_InstTmp.expr_Inst_Id = this.expr_Inst_Id;
        expr_InstTmp.nm = this.nm;
        expr_InstTmp.description = this.description;
        expr_InstTmp.ver = this.ver;
        expr_InstTmp.valid_Cd = this.valid_Cd;
        expr_InstTmp.dxMp_Id = this.dxMp_Id;
        expr_InstTmp.updateBy = this.updateBy;
        expr_InstTmp.lastUpdateBy = this.lastUpdateBy;
        expr_InstTmp.updateDt = this.updateDt;
        expr_InstTmp.persistFlg = this.persistFlg;
        expr_InstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;

        return expr_InstTmp;
    }

    copyFrom(expr_InstTmp: Expr_Inst): void {
        this.expr_Inst_Id = expr_InstTmp.expr_Inst_Id;
        this.nm = expr_InstTmp.nm;
        this.description = expr_InstTmp.description;
        this.ver = expr_InstTmp.ver;
        this.valid_Cd = expr_InstTmp.valid_Cd;
        this.dxMp_Id = expr_InstTmp.dxMp_Id;
        this.updateBy = expr_InstTmp.updateBy;
        this.lastUpdateBy = expr_InstTmp.lastUpdateBy;
        this.updateDt = expr_InstTmp.updateDt;
        this.persistFlg = expr_InstTmp.persistFlg;
        this.attr_Tab_Valid_Cd = expr_InstTmp.attr_Tab_Valid_Cd;
    }

    compare(expr_InstTmp: Expr_Inst): string {
        let expr_InstString: string = this.toString(false);
        let expr_InstTmpString: string = expr_InstTmp.toString(false);

        if (expr_InstString != expr_InstTmpString) {
            return expr_InstString + ', ' + expr_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Expr_Inst [expr_Inst_Id=" + this.expr_Inst_Id + ", nm=" + this.nm + ", description=" + this.description +
            ", valid_Cd=" + this.valid_Cd + ", dxMp_Id=" + this.dxMp_Id + ", persistFlg=" + this.persistFlg +
            ", attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd;

        if (isNotCompare) {
            str += ", ver=" + this.ver + ", updateBy=" + this.updateBy + ", lastUpdateBy=" + this.lastUpdateBy + ", updateDt=" + this.updateDt;
        }

        str += ']';
        return str;
    }
}